var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "typification-form-container",
      attrs: { row: "", wrap: "", "justify-space-between": "" }
    },
    [
      _c("input-field", {
        attrs: {
          value: "",
          label: _vm.$tc("Address", 1),
          size: "large",
          inputType: "group"
        }
      }),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          label: "",
          size: "large",
          inputType: "radio",
          radioOptions: _vm.addressOriginOptions
        },
        model: {
          value: _vm.addressOrigin,
          callback: function($$v) {
            _vm.addressOrigin = $$v
          },
          expression: "addressOrigin"
        }
      }),
      _vm._v(" "),
      _vm.addressOrigin === "Main" && !_vm.hasRequiredAddressFields
        ? _c(
            "div",
            {
              staticClass: "input-field error--text",
              staticStyle: { "font-size": "9px" }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("MissingRequiredAddressFields")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.addressOrigin === "Alternative"
        ? _c(
            "v-layout",
            {
              staticStyle: { width: "100%" },
              attrs: { row: "", wrap: "", "justify-space-between": "" }
            },
            [
              _c("input-field", {
                attrs: {
                  label: _vm.$t("AddressType"),
                  size: "25",
                  inputType: "select",
                  selectOptions: "list_address_type",
                  required: true
                },
                model: {
                  value: _vm.addressType,
                  callback: function($$v) {
                    _vm.addressType = $$v
                  },
                  expression: "addressType"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$tc("Address", 1),
                  size: "45",
                  inputType: "text",
                  required: true
                },
                model: {
                  value: _vm.address,
                  callback: function($$v) {
                    _vm.address = $$v
                  },
                  expression: "address"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$tc("Number", 1),
                  size: "15",
                  inputType: "text",
                  required: true
                },
                model: {
                  value: _vm.number,
                  callback: function($$v) {
                    _vm.number = $$v
                  },
                  expression: "number"
                }
              }),
              _vm._v(" "),
              _c(
                "input-field",
                {
                  attrs: {
                    value: _vm.noNumber,
                    label: " ",
                    size: "15",
                    inputType: "checkbox"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "checkbox-group" },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "S/N", color: "accent", ripple: false },
                        model: {
                          value: _vm.noNumber,
                          callback: function($$v) {
                            _vm.noNumber = $$v
                          },
                          expression: "noNumber"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("input-field", {
                attrs: { label: "CP4", size: "15", inputType: "number" },
                model: {
                  value: _vm.cp4,
                  callback: function($$v) {
                    _vm.cp4 = $$v
                  },
                  expression: "cp4"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: { label: "CP3", size: "15", inputType: "number" },
                model: {
                  value: _vm.cp3,
                  callback: function($$v) {
                    _vm.cp3 = $$v
                  },
                  expression: "cp3"
                }
              }),
              _vm._v(" "),
              _c("input-field", {
                attrs: {
                  label: _vm.$t("Locale"),
                  size: "70",
                  inputType: "text"
                },
                model: {
                  value: _vm.locale,
                  callback: function($$v) {
                    _vm.locale = $$v
                  },
                  expression: "locale"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input-field", {
        attrs: {
          value: "",
          label: _vm.$t("Typification"),
          size: "large",
          inputType: "group"
        }
      }),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          staticStyle: { width: "100%" },
          attrs: {
            row: "",
            wrap: "",
            "justify-space-between": "",
            "align-end": ""
          }
        },
        [
          _c("input-field", {
            attrs: {
              label: _vm.$tc("Type", 1),
              size: "25",
              inputType: "select",
              selectOptions: "list_bd_category_type",
              required: true
            },
            model: {
              value: _vm.typificationType,
              callback: function($$v) {
                _vm.typificationType = $$v
              },
              expression: "typificationType"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$t("FromFloor"),
              size: "25",
              inputType: "number",
              required: true
            },
            model: {
              value: _vm.fromFloor,
              callback: function($$v) {
                _vm.fromFloor = $$v
              },
              expression: "fromFloor"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$t("ToFloor"),
              size: "25",
              inputType: "number",
              "number-field-min": parseInt(this.fromFloor),
              required: true
            },
            model: {
              value: _vm.toFloor,
              callback: function($$v) {
                _vm.toFloor = $$v
              },
              expression: "toFloor"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$tc("Fraction", 1),
              size: "25",
              inputType: "text",
              required: true
            },
            model: {
              value: _vm.fraction,
              callback: function($$v) {
                _vm.fraction = $$v
              },
              expression: "fraction"
            }
          }),
          _vm._v(" "),
          _c("input-field", {
            attrs: {
              label: _vm.$t("Description"),
              size: "large",
              inputType: "text"
            },
            model: {
              value: _vm.description,
              callback: function($$v) {
                _vm.description = $$v
              },
              expression: "description"
            }
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticStyle: { "margin-right": "20px", "margin-top": "10px" },
              attrs: { "justify-end": "" }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    "x-small": "",
                    icon: "",
                    color: "accent",
                    disabled: _vm.addBtnDisabled,
                    loading: _vm.loading
                  },
                  on: { click: _vm.addTypification }
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5688401c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5688401c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Typification/TypificationForm.vue
// module id = null
// module chunks = 